export default {
  message_not_edited_error:
    'El mensaje no se guard\u00f3. Por favor, int\u00e9ntelo de nuevo.',
  CANCEL: 'Cancelar',
  SAVING: 'Guardando',
  generic_save: 'Guardar',
};
